import { SelectInput, required, useTranslate } from 'react-admin'
import { InvoiceType } from '../../GeneratedClients/FreeBillApi'
import firstLetterToLowerCase from '../../helpers/firstLetterToLowerCase'
import { useFormContext } from "react-hook-form";
import isInvoiceWithoutTax from '../../domain/invoice/isInvoiceWithoutTax';
import { Dispatch, SetStateAction } from 'react';

interface IProps {
  setInvoiceType: Dispatch<SetStateAction<InvoiceType>>
  isSmallBusiness?: boolean
}

const InvoiceTypeInput = ({setInvoiceType, isSmallBusiness}: IProps) => {
  const translate = useTranslate()
  const { setValue } = useFormContext()

  const handleSelect = (e: any) => {
    const invoiceType = e.target.value
    setInvoiceType(invoiceType)
    setValue("items", [{quantity: 1, discount: 0, price: 0, tax_in_percent: isInvoiceWithoutTax(invoiceType) ? 0 : 0.19}])
  }

  const choices = [
    {id: InvoiceType.StandardInvoice, name: translate(`resources.invoiceTypes.${firstLetterToLowerCase(InvoiceType.StandardInvoice)}`)},
    {id: InvoiceType.EuInvoiceService, name: translate(`resources.invoiceTypes.${firstLetterToLowerCase(InvoiceType.EuInvoiceService)}`)},
    {id: InvoiceType.EuInvoiceDelivery, name: translate(`resources.invoiceTypes.${firstLetterToLowerCase(InvoiceType.EuInvoiceDelivery)}`)},
    {id: InvoiceType.ThirdCountryInvoiceService, name: translate(`resources.invoiceTypes.${firstLetterToLowerCase(InvoiceType.ThirdCountryInvoiceService)}`)},
    {id: InvoiceType.ThirdCountryInvoiceDelivery, name: translate(`resources.invoiceTypes.${firstLetterToLowerCase(InvoiceType.ThirdCountryInvoiceDelivery)}`)},
    {id: InvoiceType.Revenues13bInvoice, name: translate(`resources.invoiceTypes.${firstLetterToLowerCase(InvoiceType.Revenues13bInvoice)}`)},
    {id: InvoiceType.SaleCarInvoice, name: translate(`resources.invoiceTypes.${firstLetterToLowerCase(InvoiceType.SaleCarInvoice)}`)},
    {id: InvoiceType.SaleCapitalAssetsInvoice, name: translate(`resources.invoiceTypes.${firstLetterToLowerCase(InvoiceType.SaleCapitalAssetsInvoice)}`)},
  ]

  const choicesSmallBusiness = [
    {id: InvoiceType.StandardInvoice, name: translate(`resources.invoiceTypes.${firstLetterToLowerCase(InvoiceType.StandardInvoice)}`)},
    {id: InvoiceType.SaleCarInvoice, name: translate(`resources.invoiceTypes.${firstLetterToLowerCase(InvoiceType.SaleCarInvoice)}`)},
    {id: InvoiceType.SaleCapitalAssetsInvoice, name: translate(`resources.invoiceTypes.${firstLetterToLowerCase(InvoiceType.SaleCapitalAssetsInvoice)}`)},
  ]

  return (
    <SelectInput 
      fullWidth 
      defaultValue={InvoiceType.StandardInvoice}
      helperText={false} 
      onChange={handleSelect} 
      source="invoiceType" 
      label="resources.invoices.invoiceType" 
      validate={required()} 
      choices={isSmallBusiness ? choicesSmallBusiness : choices} 
    />
  )
}

export default InvoiceTypeInput